var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.25 2H1.75C1.61193 2 1.5 2.11193 1.5 2.25V18.75C1.5 18.8881 1.61193 19 1.75 19H18.25C18.3881 19 18.5 18.8881 18.5 18.75V2.25C18.5 2.11193 18.3881 2 18.25 2ZM1.75 0.5C0.783502 0.5 0 1.2835 0 2.25V18.75C0 19.7165 0.783501 20.5 1.75 20.5H18.25C19.2165 20.5 20 19.7165 20 18.75V2.25C20 1.2835 19.2165 0.5 18.25 0.5H1.75Z",
    fill: "url(#paint0_linear_2571_12609)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 4.25,
    width: 3.75,
    height: 1.75,
    rx: 0.875,
    fill: "url(#paint1_linear_2571_12609)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.75,
    y: 4.25,
    width: 7.5,
    height: 1.75,
    rx: 0.875,
    fill: "url(#paint2_linear_2571_12609)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 8,
    width: 3.75,
    height: 1.75,
    rx: 0.875,
    fill: "url(#paint3_linear_2571_12609)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.75,
    y: 8,
    width: 7.5,
    height: 1.75,
    rx: 0.875,
    fill: "url(#paint4_linear_2571_12609)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 11.75,
    width: 3.75,
    height: 1.75,
    rx: 0.875,
    fill: "url(#paint5_linear_2571_12609)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8.75,
    y: 11.75,
    width: 7.5,
    height: 1.75,
    rx: 0.875,
    fill: "url(#paint6_linear_2571_12609)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2571_12609",
    x1: 0,
    y1: 0.5,
    x2: 20,
    y2: 20.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#023E8A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#2684FF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2571_12609",
    x1: 3.75,
    y1: 4.25,
    x2: 5.09124,
    y2: 7.12409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#023E8A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#2684FF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2571_12609",
    x1: 8.75,
    y1: 4.25,
    x2: 9.5245,
    y2: 7.56928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#023E8A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#2684FF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2571_12609",
    x1: 3.75,
    y1: 8,
    x2: 5.09124,
    y2: 10.8741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#023E8A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#2684FF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2571_12609",
    x1: 8.75,
    y1: 8,
    x2: 9.5245,
    y2: 11.3193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#023E8A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#2684FF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2571_12609",
    x1: 3.75,
    y1: 11.75,
    x2: 5.09124,
    y2: 14.6241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#023E8A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#2684FF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2571_12609",
    x1: 8.75,
    y1: 11.75,
    x2: 9.5245,
    y2: 15.0693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#023E8A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#2684FF",
    stopOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocs);
export default __webpack_public_path__ + "static/media/docs.9ed7af899f71e3cab566232f2760efb0.svg";
export { ForwardRef as ReactComponent };